<div class="hippo-vertical-navigation-wrapper">
    <!-- Header -->
    <div class="hippo-vertical-navigation-header">
        <ng-content select="[hippoVerticalNavigationHeader]"></ng-content>
    </div>

    <!-- Content -->
    <div
        class="hippo-vertical-navigation-content pb-24"
        hippoScrollbar
        [hippoScrollbarOptions]="{
            wheelPropagation: inner,
            suppressScrollX: true,
        }"
        #navigationContent>
        <!-- Content header -->
        <div class="hippo-vertical-navigation-content-header">
            <ng-content
                select="[hippoVerticalNavigationContentHeader]"></ng-content>
        </div>

        <!-- Items -->
        @for (item of navigation; track trackByFn($index, item)) {
            <!-- Skip the hidden items -->
            @if ((item.hidden && !item.hidden(item)) || !item.hidden) {
                <!-- Aside -->
                @if (item.type === 'aside') {
                    <hippo-vertical-navigation-aside-item
                        [item]="item"
                        [name]="name"
                        [activeItemId]="activeAsideItemId"
                        [autoCollapse]="autoCollapse"
                        [skipChildren]="true"
                        (click)="
                            toggleAside(item)
                        "></hippo-vertical-navigation-aside-item>
                }
                <!-- Basic -->
                @if (item.type === 'basic') {
                    <hippo-vertical-navigation-basic-item
                        [item]="item"
                        [name]="name"></hippo-vertical-navigation-basic-item>
                }
                <!-- Collapsable -->
                @if (item.type === 'collapsable') {
                    <hippo-vertical-navigation-collapsable-item
                        [item]="item"
                        [name]="name"
                        [autoCollapse]="
                            autoCollapse
                        "></hippo-vertical-navigation-collapsable-item>
                }
                <!-- Divider -->
                @if (item.type === 'divider') {
                    <hippo-vertical-navigation-divider-item
                        [item]="item"
                        [name]="name"></hippo-vertical-navigation-divider-item>
                }
                <!-- Group -->
                @if (item.type === 'group') {
                    <hippo-vertical-navigation-group-item
                        [item]="item"
                        [name]="name"
                        [autoCollapse]="
                            autoCollapse
                        "></hippo-vertical-navigation-group-item>
                }
                <!-- Spacer -->
                @if (item.type === 'spacer') {
                    <hippo-vertical-navigation-spacer-item
                        [item]="item"
                        [name]="name"></hippo-vertical-navigation-spacer-item>
                }
            }
        }

        <!-- Content footer -->
        <div class="hippo-vertical-navigation-content-footer">
            <ng-content
                select="[hippoVerticalNavigationContentFooter]"></ng-content>
        </div>
    </div>

    <!-- Footer -->
    <div class="hippo-vertical-navigation-footer">
        <div class="text-xs text-gray-600 text-center py-1">
            hippodata.de - {{ version }}
        </div>
        <ng-content select="[hippoVerticalNavigationFooter]"></ng-content>
    </div>
</div>

<!-- Aside -->
@if (activeAsideItemId) {
    <div
        class="hippo-vertical-navigation-aside-wrapper"
        hippoScrollbar
        [hippoScrollbarOptions]="{
            wheelPropagation: false,
            suppressScrollX: true,
        }"
        [@fadeInLeft]="position === 'left'"
        [@fadeInRight]="position === 'right'"
        [@fadeOutLeft]="position === 'left'"
        [@fadeOutRight]="position === 'right'">
        <!-- Items -->
        @for (item of navigation; track trackByFn($index, item)) {
            <!-- Skip the hidden items -->
            @if ((item.hidden && !item.hidden(item)) || !item.hidden) {
                <!-- Aside -->
                @if (item.type === 'aside' && item.id === activeAsideItemId) {
                    <hippo-vertical-navigation-aside-item
                        [item]="item"
                        [name]="name"
                        [autoCollapse]="
                            autoCollapse
                        "></hippo-vertical-navigation-aside-item>
                }
            }
        }
    </div>
}
